import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, Ref } from "vue";
import { useApiStore, type WpProject } from "@/stores/api";
//@ts-ignore
import projectGridCard from "./elements/project-grid-card.vue";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const apiStore = useApiStore();

const breakpoints = useBreakpoints(breakpointsTailwind);
const ShowMobileGrid = breakpoints.smaller("lg");

const projects: Ref<WpProject[]> = ref([]);

apiStore.getWpProjects({ per_page: 20, last_chance: 1 }).then((p: WpProject[]) => (projects.value = p));

const getColor = (color: "bg-beige-100" | "bg-beige-200" | "bg-beige-300" | "bg-brown-100" | "bg-brown-200" | "bg-gold") => {
    let text = "text-white";

    if (["bg-beige-100", "bg-beige-200", "bg-beige-300"].includes(color)) {
        text = "text-brown-200";
    }
    return `${color} ${text}`;
};

const projectsSortedByCategory = computed(() => {
    let sortedProjects: Array<WpProject | { id: 0; post_title: "coming-soon" }> = projects.value.sort((a, b) => {
        if (b.category && b.category.find((c) => c.cat_name === "sold")) {
            return -1;
        }
        return 0;
    });

    if (sortedProjects.length > 3) {
        sortedProjects.splice(4, 0, { id: 0, post_title: "coming-soon" });
    } else {
        sortedProjects.push({ id: 0, post_title: "coming-soon" });
    }

    return sortedProjects;
});

const __returned__ = { apiStore, breakpoints, ShowMobileGrid, projects, getColor, projectsSortedByCategory, projectGridCard }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})